import { CallbackObject } from 'api/core/get-page-function';
import { plainToClass } from 'class-transformer';
import { AxiosResponse } from 'axios';
import { instance } from 'api/core';
import { GetWorkersVm } from './get-workers.vm';

export const getWorkers = async (offset: string, callback: CallbackObject<GetWorkersVm>) => {
    const config = {
        headers: {
            'Content-Type': 'application/json',
        },
        params: {
            limit: 50,
            offset: offset,
        }
    };

    try {
        const res: AxiosResponse = await instance.get(`/management/workers`, config);
        callback.success(plainToClass(GetWorkersVm, res.data));
    } catch (err) {
        if (callback.error) callback.error(err);
    }
};
